// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","footer_box":"Footer_footer_box__kX4xC","icons":"Footer_icons__JfHkL","footer_box_icons":"Footer_footer_box_icons__HhWeo"};